
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as contactB1SRcWh20LS1LpUZVL5e37fPPKP6FJFkP6sHRKNtk_8Meta } from "/workspace/frontend/pages/contact.vue?macro=true";
import { default as listk9kbUSL7yA7_whugqTzVbtnMthHZhvREe0b7neA4GUEMeta } from "/workspace/frontend/pages/news/list.vue?macro=true";
import { default as login0L8Lxq_45Gr7ks_45NRDnf7tJ_45Pv2tB7Tx6T3OuOiaVWH_45wMeta } from "/workspace/frontend/pages/auth/login.vue?macro=true";
import { default as logoutyrmkIuMDqvdyuEw_zEFopHJuupYesMzZ9LWavKhaB_45cMeta } from "/workspace/frontend/pages/auth/logout.vue?macro=true";
import { default as forward_4591SUe8U8CuGjh3viYmtAqWFol8G7I_NrbVpp915ezwMeta } from "/workspace/frontend/pages/auth/forward.vue?macro=true";
import { default as setemailtHq1i0Ta7vrqt1D_45y0TqPpLFJ8F8xWq7NZDxDFf_96oMeta } from "/workspace/frontend/pages/auth/setemail.vue?macro=true";
import { default as list4AIQNDVNRbFA4qrU8PBvivNrEX64n_45bH9DpxmOxc21sMeta } from "/workspace/frontend/pages/schedule/list.vue?macro=true";
import { default as shiftsY_LEJabKEjA8UCaCN3SK6XDQgmeSlKDuUiyZYH10YzYMeta } from "/workspace/frontend/pages/network/shifts.vue?macro=true";
import { default as contactbNfsS0_456VVpmumGXSneAA9CncE7K8KV_WCOnpFDXdGEMeta } from "/workspace/frontend/pages/profile/contact.vue?macro=true";
import { default as fillprofileL3FZ4YfHXVsUZLu_bNjsaFbciue6G2qMRbKsH79k7osMeta } from "/workspace/frontend/pages/auth/fillprofile.vue?macro=true";
import { default as terminationX7Yxrib0ytAm0YEUaaYrdQPtS67SiFmkSXZu9xZREWQMeta } from "/workspace/frontend/pages/auth/termination.vue?macro=true";
import { default as rotatingZXe8HMpPwOLcr_45vBk1GDJFxSjnse7d4VEV20Nhgg0zUMeta } from "/workspace/frontend/pages/network/rotating.vue?macro=true";
import { default as overviewVgUKeraen6ikzvZruvMQpqs3_45rgTmT35jqthRFe0bHkMeta } from "/workspace/frontend/pages/profile/overview.vue?macro=true";
import { default as paymentsvWvHr978SMS_ItubUEexcubsHTPkDbMh6cbfLIJiNggMeta } from "/workspace/frontend/pages/profile/payments.vue?macro=true";
import { default as historyOdEv_xvb2Lxy_45DDvltpcSQYdA61By3Z7GDJVoqjVMCwMeta } from "/workspace/frontend/pages/schedule/history.vue?macro=true";
import { default as overviewfaG8SLJe2mNQL_j7q5dbVtXhQofQr9Gw9k6P0vz9_45FsMeta } from "/workspace/frontend/pages/licenses/overview.vue?macro=true";
import { default as _91id_93EARt4h_45MmWkyNbPJ3mM2D1IbdJDxr_45t0QoPP60Ff8dEMeta } from "/workspace/frontend/pages/network/user/[id].vue?macro=true";
import { default as _91id_93WF8JUOCIE0UWCQDneaNxju5G8Ta_dwgdwNPL1prw_45RcMeta } from "/workspace/frontend/pages/news/details/[id].vue?macro=true";
import { default as finishJcgVRE8PYqHJXM6STl_45t0G_45irGri_axHPO5noy0kVQ0Meta } from "/workspace/frontend/pages/onboarding/finish.vue?macro=true";
import { default as documentsOkeGNQi_u8leFlZaqOvvIMb0lANmPlcyMpQ51DkkL5QMeta } from "/workspace/frontend/pages/profile/documents.vue?macro=true";
import { default as requestsvJtcyooLA1if_3QrtKlNr9AN_svhkg59uHy3V8jXNpkMeta } from "/workspace/frontend/pages/schedule/requests.vue?macro=true";
import { default as calendar5ruV1A3vzzrSDNDZpCMXHKKp60Z85Cg2TXRytajjwi4Meta } from "/workspace/frontend/pages/dashboard/calendar.vue?macro=true";
import { default as external2DOsFDee3okI5IaJg58Z_450hlA6_EUO9oDQ_viXMg4HEMeta } from "/workspace/frontend/pages/dashboard/external.vue?macro=true";
import { default as rotating9YOQC4n8qlIUrpMnVbiCY7mlwRFNAjSe5VxQnvWTkR0Meta } from "/workspace/frontend/pages/dashboard/rotating.vue?macro=true";
import { default as forwardxOmFC7UgSKkeHs8lztnUMHaOcdvfLDvFpUewMbl3g0UMeta } from "/workspace/frontend/pages/onboarding/forward.vue?macro=true";
import { default as regulationc2OFED5dcm_b5edPLLzO9xhWKeebzi0AEbwqudF_9mgMeta } from "/workspace/frontend/pages/profile/regulation.vue?macro=true";
import { default as startHTvch9PdFl7_fqK4vJABtMBHaMZbQPRk0JiA3k33IaMMeta } from "/workspace/frontend/pages/rotationplan/start.vue?macro=true";
import { default as approvalsbC7rTrjxhjUymALguYpfb2aB1bYtlcjPtf91lMUclygMeta } from "/workspace/frontend/pages/schedule/approvals.vue?macro=true";
import { default as _91id_93bJVtphaUdV8FVEhPAVeIYjVMfl4_45EdVbBEFAUDVoqycMeta } from "/workspace/frontend/pages/schedule/edit/[id].vue?macro=true";
import { default as rotatingd0jwkwLOgChpJyGavvVMqJmFNnYZs3mVM30dlS6rpiQMeta } from "/workspace/frontend/pages/onboarding/rotating.vue?macro=true";
import { default as timeperiodsz17_KYVn3z9zFVJHf7mgdbXVk_450lLG7E_45BBmHD4bgdcMeta } from "/workspace/frontend/pages/profile/timeperiods.vue?macro=true";
import { default as overview8gt3BXdUmK2Py5lTGWsbb7_45YYeRSzXw1k8oSNqeXahgMeta } from "/workspace/frontend/pages/competences/overview.vue?macro=true";
import { default as organisationDjFFHwqB9_DN__gMu37DF9CASL2mLkEV0MU5tSUuPKkMeta } from "/workspace/frontend/pages/network/organisation.vue?macro=true";
import { default as servicegroupsnao1l2uRaGgISCcsLS33luIaZw4U_YWREVkKO35JYP4Meta } from "/workspace/frontend/pages/network/servicegroups.vue?macro=true";
import { default as index9diKzpjJVY0bm7HD_0JaNizzeVXM17B1oi6qu_SRiNEMeta } from "/workspace/frontend/pages/auth/setpassword/index.vue?macro=true";
import { default as administrativek9_dF7s66Xw4_j639JGZ1IS7V7YvvXFix_45BcF2EFPGoMeta } from "/workspace/frontend/pages/network/administrative.vue?macro=true";
import { default as catalog61ela2j3pSl6s_459XJcuEna2ap95GEYpm0TOEI0qZI9UMeta } from "/workspace/frontend/pages/qualifications/catalog.vue?macro=true";
import { default as shiftplanIBvWVBAEpnR0KyuMY9YQy71_45AelMXVp_45xyJ5N2kb1DsMeta } from "/workspace/frontend/pages/rotationplan/shiftplan.vue?macro=true";
import { default as configurationnvts2ODG3nyaKmF2Oy7nFB1Y78tBiNV0MzqQ8aYmNiAMeta } from "/workspace/frontend/pages/schedule/configuration.vue?macro=true";
import { default as congratsz6JB30i9clOMTvVcLOJWvKsGebqiFHegGVrd2UGbGkMMeta } from "/workspace/frontend/pages/administrative/congrats.vue?macro=true";
import { default as overviewV_aQRueHTwkt_45jzrQdpvwAZ9PEE0XyGZl9ievrsAWS4Meta } from "/workspace/frontend/pages/qualifications/overview.vue?macro=true";
import { default as distributeAeHHqBD5PLXJILa537OrDSGkiCp4e0d8S9RHcHP694IMeta } from "/workspace/frontend/pages/rotationplan/distribute.vue?macro=true";
import { default as printflowKb7i_J_45kduLMp6zP14YWu4It1_45uR1_459TfGqSR8my1O0Meta } from "/workspace/frontend/pages/schedule/flow/printflow.vue?macro=true";
import { default as _91token_93tyLoSGAvDPnUFAdosmHhZ3wwzb1_Dd5qQP5EUv1UpYIMeta } from "/workspace/frontend/pages/auth/setpassword/[token].vue?macro=true";
import { default as administrativeWXXux3K8HPE_1fEIE_45_45a2ijq4kwPYMnYWHJJy3SlvDUMeta } from "/workspace/frontend/pages/dashboard/administrative.vue?macro=true";
import { default as indexJEpaqfv3PeayXWekz_0vCqbpN7AyUBDMvSI4fc7WtKgMeta } from "/workspace/frontend/pages/schedule/flow/[id]/index.vue?macro=true";
import { default as administrativeCXMJYkKX43GeJZfBfPxVEAp7zDqvYflPxVr_ZFPC_45_kMeta } from "/workspace/frontend/pages/onboarding/administrative.vue?macro=true";
import { default as printshiftplanhm37N3LPoOCu0nkUX5yfnPRQYXagZCloDgp9ec4050sMeta } from "/workspace/frontend/pages/rotationplan/printshiftplan.vue?macro=true";
import { default as printdistributionSizli5C223UpPaxd2FXPDTYp0sKiSqbSKKqoqA8vgVMMeta } from "/workspace/frontend/pages/rotationplan/printdistribution.vue?macro=true";
import { default as _91specialityId_93xUAYhfxL0KB9TzPQcj8bn5Rs9Li_sH4xDZHPH9ig_UQMeta } from "/workspace/frontend/pages/schedule/flow/[id]/[specialityId].vue?macro=true";
import { default as _91id_93ajPjW8sea13ybGYA_Ltp_45wp5OK26dCp_45LAx2j5MMVIcMeta } from "/workspace/frontend/pages/network/profile/administrative/[id].vue?macro=true";
import { default as component_45stub2r4q7js68RCcrBYTjr4yZ_l_45FHhqz0W_45hGknKyQa2agMeta } from "/workspace/node_modules/.pnpm/nuxt@3.20.2_@emnapi+core@1.9.2_@emnapi+runtime@1.9.2_@parcel+watcher@2.5.6_@types+node@_6fe0d62be4ded556d894a05336dd022f/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub2r4q7js68RCcrBYTjr4yZ_l_45FHhqz0W_45hGknKyQa2ag } from "/workspace/node_modules/.pnpm/nuxt@3.20.2_@emnapi+core@1.9.2_@emnapi+runtime@1.9.2_@parcel+watcher@2.5.6_@types+node@_6fe0d62be4ded556d894a05336dd022f/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "contact",
    path: "/contact",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/contact.vue")
  },
  {
    name: "news-list",
    path: "/news/list",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/news/list.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: { ...(login0L8Lxq_45Gr7ks_45NRDnf7tJ_45Pv2tB7Tx6T3OuOiaVWH_45wMeta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/workspace/frontend/pages/auth/login.vue")
  },
  {
    name: "auth-logout",
    path: "/auth/logout",
    meta: logoutyrmkIuMDqvdyuEw_zEFopHJuupYesMzZ9LWavKhaB_45cMeta || {},
    component: () => import("/workspace/frontend/pages/auth/logout.vue")
  },
  {
    name: "auth-forward",
    path: "/auth/forward",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/auth/forward.vue")
  },
  {
    name: "auth-setemail",
    path: "/auth/setemail",
    meta: { ...(setemailtHq1i0Ta7vrqt1D_45y0TqPpLFJ8F8xWq7NZDxDFf_96oMeta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/workspace/frontend/pages/auth/setemail.vue")
  },
  {
    name: "schedule-list",
    path: "/schedule/list",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/schedule/list.vue")
  },
  {
    name: "network-shifts",
    path: "/network/shifts",
    meta: {"middleware":["authenticated","daily-planning-admin"]},
    component: () => import("/workspace/frontend/pages/network/shifts.vue")
  },
  {
    name: "profile-contact",
    path: "/profile/contact",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/profile/contact.vue")
  },
  {
    name: "auth-fillprofile",
    path: "/auth/fillprofile",
    meta: { ...(fillprofileL3FZ4YfHXVsUZLu_bNjsaFbciue6G2qMRbKsH79k7osMeta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/workspace/frontend/pages/auth/fillprofile.vue")
  },
  {
    name: "auth-termination",
    path: "/auth/termination",
    meta: { ...(terminationX7Yxrib0ytAm0YEUaaYrdQPtS67SiFmkSXZu9xZREWQMeta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/workspace/frontend/pages/auth/termination.vue")
  },
  {
    name: "network-rotating",
    path: "/network/rotating",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/network/rotating.vue")
  },
  {
    name: "profile-overview",
    path: "/profile/overview",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/profile/overview.vue")
  },
  {
    name: "profile-payments",
    path: "/profile/payments",
    meta: paymentsvWvHr978SMS_ItubUEexcubsHTPkDbMh6cbfLIJiNggMeta || {},
    component: () => import("/workspace/frontend/pages/profile/payments.vue")
  },
  {
    name: "schedule-history",
    path: "/schedule/history",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/schedule/history.vue")
  },
  {
    name: "licenses-overview",
    path: "/licenses/overview",
    meta: overviewfaG8SLJe2mNQL_j7q5dbVtXhQofQr9Gw9k6P0vz9_45FsMeta || {},
    component: () => import("/workspace/frontend/pages/licenses/overview.vue")
  },
  {
    name: "network-user-id",
    path: "/network/user/:id()",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/network/user/[id].vue")
  },
  {
    name: "news-details-id",
    path: "/news/details/:id()",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/news/details/[id].vue")
  },
  {
    name: "onboarding-finish",
    path: "/onboarding/finish",
    meta: { ...(finishJcgVRE8PYqHJXM6STl_45t0G_45irGri_axHPO5noy0kVQ0Meta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/workspace/frontend/pages/onboarding/finish.vue")
  },
  {
    name: "profile-documents",
    path: "/profile/documents",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/profile/documents.vue")
  },
  {
    name: "schedule-requests",
    path: "/schedule/requests",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/schedule/requests.vue")
  },
  {
    name: "dashboard-calendar",
    path: "/dashboard/calendar",
    meta: {"middleware":["authenticated","daily-planning-rotating"]},
    component: () => import("/workspace/frontend/pages/dashboard/calendar.vue")
  },
  {
    name: "dashboard-external",
    path: "/dashboard/external",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/dashboard/external.vue")
  },
  {
    name: "dashboard-rotating",
    path: "/dashboard/rotating",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/dashboard/rotating.vue")
  },
  {
    name: "onboarding-forward",
    path: "/onboarding/forward",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/onboarding/forward.vue")
  },
  {
    name: "profile-regulation",
    path: "/profile/regulation",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/profile/regulation.vue")
  },
  {
    name: "rotationplan-start",
    path: "/rotationplan/start",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/rotationplan/start.vue")
  },
  {
    name: "schedule-approvals",
    path: "/schedule/approvals",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/schedule/approvals.vue")
  },
  {
    name: "schedule-edit-id",
    path: "/schedule/edit/:id()",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/schedule/edit/[id].vue")
  },
  {
    name: "onboarding-rotating",
    path: "/onboarding/rotating",
    meta: { ...(rotatingd0jwkwLOgChpJyGavvVMqJmFNnYZs3mVM30dlS6rpiQMeta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/workspace/frontend/pages/onboarding/rotating.vue")
  },
  {
    name: "profile-timeperiods",
    path: "/profile/timeperiods",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/profile/timeperiods.vue")
  },
  {
    name: "competences-overview",
    path: "/competences/overview",
    meta: {"middleware":["authenticated","network-competences-admin"]},
    component: () => import("/workspace/frontend/pages/competences/overview.vue")
  },
  {
    name: "network-organisation",
    path: "/network/organisation",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/network/organisation.vue")
  },
  {
    name: "network-servicegroups",
    path: "/network/servicegroups",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/network/servicegroups.vue")
  },
  {
    name: "auth-setpassword",
    path: "/auth/setpassword",
    meta: index9diKzpjJVY0bm7HD_0JaNizzeVXM17B1oi6qu_SRiNEMeta || {},
    component: () => import("/workspace/frontend/pages/auth/setpassword/index.vue")
  },
  {
    name: "network-administrative",
    path: "/network/administrative",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/network/administrative.vue")
  },
  {
    name: "qualifications-catalog",
    path: "/qualifications/catalog",
    meta: {"middleware":["authenticated","qualifications-access"]},
    component: () => import("/workspace/frontend/pages/qualifications/catalog.vue")
  },
  {
    name: "rotationplan-shiftplan",
    path: "/rotationplan/shiftplan",
    meta: {"middleware":["authenticated","daily-planning-admin"]},
    component: () => import("/workspace/frontend/pages/rotationplan/shiftplan.vue")
  },
  {
    name: "schedule-configuration",
    path: "/schedule/configuration",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/schedule/configuration.vue")
  },
  {
    name: "administrative-congrats",
    path: "/administrative/congrats",
    meta: congratsz6JB30i9clOMTvVcLOJWvKsGebqiFHegGVrd2UGbGkMMeta || {},
    component: () => import("/workspace/frontend/pages/administrative/congrats.vue")
  },
  {
    name: "qualifications-overview",
    path: "/qualifications/overview",
    meta: {"middleware":["authenticated","qualifications-access"]},
    component: () => import("/workspace/frontend/pages/qualifications/overview.vue")
  },
  {
    name: "rotationplan-distribute",
    path: "/rotationplan/distribute",
    meta: {"middleware":["authenticated","rotation-planning-admin"]},
    component: () => import("/workspace/frontend/pages/rotationplan/distribute.vue")
  },
  {
    name: "schedule-flow-printflow",
    path: "/schedule/flow/printflow",
    meta: { ...(printflowKb7i_J_45kduLMp6zP14YWu4It1_45uR1_459TfGqSR8my1O0Meta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/workspace/frontend/pages/schedule/flow/printflow.vue")
  },
  {
    name: "auth-setpassword-token",
    path: "/auth/setpassword/:token()",
    meta: _91token_93tyLoSGAvDPnUFAdosmHhZ3wwzb1_Dd5qQP5EUv1UpYIMeta || {},
    component: () => import("/workspace/frontend/pages/auth/setpassword/[token].vue")
  },
  {
    name: "dashboard-administrative",
    path: "/dashboard/administrative",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/dashboard/administrative.vue")
  },
  {
    name: "schedule-flow-id",
    path: "/schedule/flow/:id()",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/schedule/flow/[id]/index.vue")
  },
  {
    name: "onboarding-administrative",
    path: "/onboarding/administrative",
    meta: { ...(administrativeCXMJYkKX43GeJZfBfPxVEAp7zDqvYflPxVr_ZFPC_45_kMeta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/workspace/frontend/pages/onboarding/administrative.vue")
  },
  {
    name: "rotationplan-printshiftplan",
    path: "/rotationplan/printshiftplan",
    meta: { ...(printshiftplanhm37N3LPoOCu0nkUX5yfnPRQYXagZCloDgp9ec4050sMeta || {}), ...{"middleware":["authenticated","daily-planning-admin"]} },
    component: () => import("/workspace/frontend/pages/rotationplan/printshiftplan.vue")
  },
  {
    name: "rotationplan-printdistribution",
    path: "/rotationplan/printdistribution",
    meta: { ...(printdistributionSizli5C223UpPaxd2FXPDTYp0sKiSqbSKKqoqA8vgVMMeta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/workspace/frontend/pages/rotationplan/printdistribution.vue")
  },
  {
    name: "schedule-flow-id-specialityId",
    path: "/schedule/flow/:id()/:specialityId()",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/schedule/flow/[id]/[specialityId].vue")
  },
  {
    name: "network-profile-administrative-id",
    path: "/network/profile/administrative/:id()",
    meta: {"middleware":"authenticated"},
    component: () => import("/workspace/frontend/pages/network/profile/administrative/[id].vue")
  },
  {
    name: component_45stub2r4q7js68RCcrBYTjr4yZ_l_45FHhqz0W_45hGknKyQa2agMeta?.name,
    path: "/",
    component: component_45stub2r4q7js68RCcrBYTjr4yZ_l_45FHhqz0W_45hGknKyQa2ag
  }
]